/* SWAAP - mesure des clics (sans cookies)
   -------------------------------------------------
   Role : nommer les clics qui comptent, pour que l'outil
   de mesure d'audience les compte comme des evenements.

   Ce fichier n'envoie rien par lui-meme. Il pose seulement des
   attributs sur les liens et les boutons. Si l'outil de mesure
   n'est pas charge, il ne se passe strictement rien et aucune
   erreur n'est levee.
*/
(function () {
  'use strict';

  var LANGUE = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();

  /* Quel nom d'evenement pour quelle destination */
  function nomLien(href) {
    if (!href) return null;
    var h = href.toLowerCase();

    if (h.indexOf('configurateur.swaap.ch') > -1) return 'cta-configurateur';
    if (h.indexOf('swaap-configurateur.vercel.app') > -1) return 'cta-configurateur-ancien-lien';
    if (h.indexOf('tel:') === 0) return 'clic-telephone';
    if (h.indexOf('mailto:') === 0) return 'clic-email';
    if (h.indexOf('wa.me') > -1 || h.indexOf('api.whatsapp.com') > -1) return 'clic-whatsapp';
    if (h.indexOf('catalogue') > -1 || h.indexOf('catalog') > -1) return 'cta-catalogue';
    if (h.indexOf('devis') > -1 || h.indexOf('quote') > -1 || h.indexOf('angebot') > -1 || h.indexOf('preventivo') > -1) return 'cta-devis';
    if (h.indexOf('/pages/event') > -1) return 'univers-evenementiel';
    if (h.indexOf('home-staging') > -1) return 'univers-home-staging';
    if (h.indexOf('expats') > -1 || h.indexOf('furnish-my-home') > -1) return 'univers-logement';
    if (h.indexOf('/pages/shop') > -1) return 'univers-achat';
    if (h.indexOf('/pages/contact') > -1 || h.indexOf('nous-contacter') > -1) return 'clic-contact';
    if (h.indexOf('/collections/') > -1 || h.indexOf('/products/') > -1) return 'clic-boutique';
    return null;
  }

  /* Boutons pilotes par le theme, qui n'ont pas d'adresse */
  function nomBouton(b) {
    if (b.hasAttribute('data-skip')) return 'visite-passee';
    if (b.hasAttribute('data-chapter')) return 'visite-chapitre';
    if (b.getAttribute('name') === 'locale_code') return 'changement-langue';
    return null;
  }

  function libelle(el) {
    var t = el.textContent || el.getAttribute('aria-label') || '';
    return t.replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function commun(el, nom) {
    el.setAttribute('data-umami-event', nom);
    el.setAttribute('data-umami-event-page', window.location.pathname.slice(0, 80));
    el.setAttribute('data-umami-event-langue', LANGUE);
    var lib = libelle(el);
    if (lib) el.setAttribute('data-umami-event-libelle', lib);
  }

  /* Pose les attributs que l'outil de mesure sait lire */
  function marquer() {
    var liens = document.querySelectorAll('a[href]:not([data-swaap-vu])');
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      a.setAttribute('data-swaap-vu', '1');
      if (a.hasAttribute('data-umami-event')) continue;
      var nom = nomLien(a.getAttribute('href'));
      if (nom) commun(a, nom);
    }

    var boutons = document.querySelectorAll('button:not([data-swaap-vu])');
    for (var j = 0; j < boutons.length; j++) {
      var b = boutons[j];
      b.setAttribute('data-swaap-vu', '1');
      if (b.hasAttribute('data-umami-event')) continue;
      var nb = nomBouton(b);
      if (!nb) continue;
      commun(b, nb);
      if (b.hasAttribute('data-chapter')) {
        b.setAttribute('data-umami-event-chapitre', b.getAttribute('data-chapter'));
      }
      if (b.getAttribute('name') === 'locale_code') {
        b.setAttribute('data-umami-event-vers', b.getAttribute('value') || '');
      }
    }
  }

  /* Envois de formulaire : catalogue, contact, newsletter.
     Le selecteur de langue est un formulaire aussi : deja compte
     par le bouton, on l'ecarte pour ne pas fausser le chiffre. */
  function surEnvoi(ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = (f.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/localization') > -1) return;
    try {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('envoi-formulaire', {
          page: window.location.pathname.slice(0, 80),
          langue: LANGUE,
          formulaire: (f.getAttribute('id') || action || 'formulaire').slice(0, 60)
        });
      }
    } catch (e) {
      /* ne jamais bloquer la page pour une mesure */
    }
  }

  function demarrer() {
    marquer();
    document.addEventListener('submit', surEnvoi, true);

    /* Le theme injecte des liens apres coup : menus, panier, popups */
    if (window.MutationObserver) {
      var enAttente = false;
      var observateur = new MutationObserver(function () {
        if (enAttente) return;
        enAttente = true;
        setTimeout(function () {
          enAttente = false;
          marquer();
        }, 400);
      });
      observateur.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();